import { defineStyleConfig } from '@chakra-ui/system';

export const CloseButton = defineStyleConfig({
    baseStyle: {
        _hover: {
            background: 'none',
        },
    },
    sizes: {
        lg: {
            height: 4,
            width: 4,
        },
    },
});
